import { serverURL } from '../index'
import AsyncStorage from '@react-native-async-storage/async-storage';

export const storeData = async (value) => {
    try {
        await AsyncStorage.setItem('@MessageCreated', value);
        return JSON.stringify(value);
    } catch (e) {
        console.log("Error writing UUID: " + e)
    }
}

export async function checkMessageCreated(){
    const getData = async () => {
        try {
            const value = await AsyncStorage.getItem('@MessageCreated');
            if(value != null){
                return value;
            }else{
                return "false";
            }
        } catch(e) {
            console.log("Error reading MessageCreated: " + e);
        }
    }
    return new Promise((resolve, reject) => {
        getData().then((response) => {
            resolve(response);
        }).catch((e) => {
            reject();
        });   
    })
}